
import React from 'react'
import { MainDialog } from '../Dialgos/MainDialog'
import { Button } from '../ui/button'
import { IoIosAdd } from 'react-icons/io'
import { useTranslation } from 'react-i18next'
import CouponForm from './form/CouponForm'    
import { indexStore } from 'src/store/indexStore'
function AddCouponsModel() {
  const { t } = useTranslation();
  const { createCouponFunction } = indexStore();

  const handleSubmit = (values) => {
    createCouponFunction(values);
  };
  return (
  <MainDialog
    title={`${t("gloabl.add")} ${t(`gloabl.copun`)}`}
    trigger={
      <Button className="">
        <IoIosAdd />
        <span className="ml-2 hidden md:block">
          {t("gloabl.add")} {t(`gloabl.copun`)}
        </span>
      </Button>
    }
  >
    <CouponForm onSubmit={handleSubmit} editMode={false} />
  </MainDialog>
  )
}

export default AddCouponsModel